import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import ShareBtn from '../../assets/share-icon.svg';
import './ShareModal.css';

export const ShareModal = ({ shareUrl }) => {
  const isMobile = window.screen.width < 769;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState(0);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPrivacy(0);
  };

  return (
    <>
      <div onClick={showModal} style={{ right: "10px", top: "10px", cursor: "pointer", zIndex: 1 }} >
        <img src={ShareBtn} style={{ height: isMobile ? "20px" : "25px" }} />
      </div>
      <Modal
        title="Share with People"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        className={`share-doc-modal`}
      >
        <ShareModalContent shareUrl={shareUrl} setIsModalVisible={setIsModalVisible} privacy={privacy} setPrivacy={setPrivacy} />
      </Modal>
    </>
  );
};
